// extracted by mini-css-extract-plugin
export var animationContainer = "_ox-0";
export var footer = "_ox-1";
export var gray = "_ox-2";
export var lineItem = "_ox-3";
export var lineItemImage = "_ox-4";
export var lineItemInfo = "_ox-5";
export var lineItemText = "_ox-6";
export var lineItems = "_ox-7";
export var modalContent = "_ox-8";
export var options = "_ox-9";
export var orderName = "_ox-a";
export var refundAmount = "_ox-b";